import PlanOverview from "./PlanOverview";
import ProfileOverview from "./ProfileOverview";
import QuestionMark from "../../../../common/components/QuestionMark";
import LogoutButton from "./LogoutButton";

import "./settings-content.scss";

const SettingsContent = () => {
  return (
    <div className="settings-container">
      <h1>Settings</h1>
      <div className="settings-content">
        <ProfileOverview />
        <PlanOverview />
      </div>
      <QuestionMark />
    </div>
  );
};
export default SettingsContent;
